
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16.338","height":"16.338","viewBox":"0 0 16.338 16.338"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Icon feather-download","fill":"none","stroke":"#fff","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}},[_c('path',{attrs:{"data-name":"Path 1112","d":"M15.338 10.559v3.186a1.593 1.593 0 01-1.593 1.593H2.593A1.593 1.593 0 011 13.745v-3.186"}}),_c('path',{attrs:{"data-name":"Path 1113","d":"M4.186 6.576l3.983 3.983 3.982-3.983"}}),_c('path',{attrs:{"data-name":"Path 1114","d":"M8.169 10.559V1"}})])])
          )
        }
      }
    